module.exports = __webpack_public_path__ + "static/media/Undertaking_V2.04fb1a1d.pdf";